import { BaseModel } from "src/app/models/base.model";
import { AppUser } from "src/app/models/user/app-user.model";
import { ValidationType } from "./validation-type.model";

export class RegisterResponseModel extends BaseModel {
    success: boolean;
    errors: string[];
    warnings: string[];
    user: AppUser;
    validationType: ValidationType;
}
